export const getTeacherRedirectOnLogin = (postLoginDestination?: string) => {
  if (postLoginDestination) {
    return postLoginDestination;
  } else {
    return "/teacher";
  }
};
